


import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MarketingClientAcquisition = () => {
  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/*  HERO SECTION  */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1432888622747-4eb9a8f5a70d?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
          >
            Ads & Patient Acquisition
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Home
            </Link>
            <span className="text-white text-2xl">|</span>
            <Link 
              to="/services" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Services
            </Link>
            <span className="text-white text-2xl">|</span>
            <span className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold">
              Ads & Patient Acquisition
            </span>
          </motion.div>
        </div>
      </section>

      {/*  CONTENT SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Image & Tagline */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              {/* Healthcare Marketing Tag */}
              <span className="inline-block px-4 py-2 border border-gray-300 rounded-md text-gray-600 text-sm mb-6">
                Healthcare Digital Marketing
              </span>
              
              {/* Tagline */}
              <h2 className="text-2xl lg:text-5xl font-bold text-[#19354a] mb-8">
                The Best <span className="text-[#19354a]">Healthcare Growth Ecosystem</span> for Doctors To Your Rescue!
              </h2>
              
              <img 
                src="/images/hearts.png" 
                alt="Patient Acquisition Marketing"
                className="w-full max-w-[450px] h-auto mx-auto"
              />
            </motion.div>

            {/* Right - Content */}
            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                In today's digital healthcare landscape, patients are searching online for doctors and medical services every day. With the rapid shift to digital, healthcare providers need strategic online advertising to stay visible and attract new patients. Yet, many medical practices find it challenging to keep up with these evolving marketing trends.
              </motion.p>
              
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                So, if patient acquisition through digital ads stresses you out, worry not! As the best <strong className="text-[#19354a]">healthcare marketing company for doctors</strong>, Docmize is committed to delivering exceptional results and offering seamless solutions for medical practices to grow their patient base effortlessly through targeted advertising.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                Docmize offers cutting-edge advertising services to help medical practices achieve measurable patient growth through Google Ads, Meta Ads, and social media marketing. With our HIPAA-compliant approach, your practice can gain trust and credibility while attracting qualified patients ready to book appointments.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-[#19354a] font-semibold leading-relaxed mb-8"
              >
                Don't just be seen—be the first choice. Partner with Docmize and watch your patient base grow consistently! Contact us today to get started.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <Link 
                  to="/contact" 
                  className="inline-block px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
                >
                  GET A QUOTE
                </Link>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      {/*  WHY CHOOSE US - BLUE SECTION  */}
      <section className="relative py-20 overflow-hidden">
        <div 
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(135deg, #0f1c3f 0%, #1a2d5e 50%, #152349 100%)'
          }}
        />
        
        <div className="absolute inset-0 overflow-hidden">
          <div 
            className="absolute inset-0"
            style={{
              backgroundImage: `repeating-linear-gradient(
                45deg,
                transparent,
                transparent 50px,
                rgba(59, 130, 246, 0.1) 50px,
                rgba(59, 130, 246, 0.1) 52px
              )`
            }}
          />
          <div className="absolute top-0 left-[20%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[40%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/30 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[60%] w-[3px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[80%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/15 to-transparent transform rotate-[30deg] origin-top"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4">
              Why Choose Our Healthcare Marketing Services?
            </h2>
            <p className="text-white/70 text-lg">
              Here's why doctors trust us with their patient acquisition:
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-x-16 gap-y-8 max-w-5xl mx-auto">
            
            <div className="space-y-8">
              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Strategic Google Ads campaigns targeting patients actively searching for doctors</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Meta Ads (Facebook & Instagram) optimized for local patient acquisition</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Advanced patient lead funnels and appointment booking optimization</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Complete social media management for medical practices</p>
              </motion.div>
            </div>

            <div className="space-y-8">
              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">HIPAA-compliant patient communication and marketing campaigns</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Healthcare content strategy and consistent patient engagement</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Email marketing automation for patient retention and recalls</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Comprehensive performance analytics and patient acquisition ROI reporting</p>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      {/*  OUR SERVICES SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Our Ads & Patient Acquisition <span className="text-[#19354a]">Services</span>
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Comprehensive advertising solutions to attract and retain patients
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {/* Service 1 - ORANGE */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Google Ads for Doctors</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Strategic Google Ads campaigns targeting patients searching for medical services.
              </p>
            </motion.div>

            {/* Service 2 - BLUE */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Meta Ads (Facebook & Instagram)</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Local patient acquisition through Facebook and Instagram advertising.
              </p>
            </motion.div>

            {/* Service 3 - ORANGE */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Patient Lead Generation</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Build high-converting funnels that turn prospects into booked appointments.
              </p>
            </motion.div>

            {/* Service 4 - BLUE */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Social Media Management</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Complete social media presence management for medical practices.
              </p>
            </motion.div>

            {/* Service 5 - BLUE */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare Content Planning</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Strategic healthcare content calendars and consistent patient engagement.
              </p>
            </motion.div>

            {/* Service 6 - BLUE */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">LinkedIn Ads (Hospitals & Groups)</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Professional advertising for hospitals and medical group practices.
              </p>
            </motion.div>

            {/* Service 7 - BLUE */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.7 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Patient Email Marketing</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Automated email sequences for patient retention and appointment reminders.
              </p>
            </motion.div>

            {/* Service 8 - BLUE */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.8 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Ad Monitoring & Optimization</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Detailed reporting and insights to optimize your patient acquisition campaigns.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

      {/*  BENEFITS SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Reap the Benefits of Healthcare Marketing Services
            </h2>
            <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-6">
              at <span className="text-[#19354a]">Docmize</span>
            </h3>
            <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Our comprehensive healthcare marketing strategies are designed to attract, engage, and convert prospective patients into loyal patients for your medical practice.
            </p>
          </motion.div>

          {/* Benefit 1 - Image Right */}
          {/* <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#fff4e6] p-6 lg:p-10 flex items-center border-l-4 border-[#E85A2C]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
                  Strategic Campaign Planning
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We begin by understanding your medical practice goals and target patient demographics. Our team develops comprehensive healthcare marketing strategies tailored to your specialty, ensuring every campaign drives measurable patient appointments and practice growth.
                </p>
              </div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e8f4fc]"
            >
              <img 
                src="/images/meta7.gif" 
                alt="Healthcare Campaign Planning"
                className="w-full h-full min-h-[100px] object-cover"
              />
            </motion.div>
          </div> */}

          {/* Benefit 2 - Image Left */}
          <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#e6f7f0] order-2 lg:order-1"
            >
              <img 
                src="/images/meta6.png" 
                alt="Healthcare Social Media"
                className="w-full h-full min-h-[200px] object-cover"
              />
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e6f2e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#19354a]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
                  Multi-Platform Healthcare Presence
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We establish and manage your medical practice presence across all relevant platforms. From Google Ads and Facebook to Instagram and LinkedIn, we ensure HIPAA-compliant messaging and maximum reach to attract local patients.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Benefit 3 - Image Right */}
          <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#f0e6f7] p-6 lg:p-10 flex items-center border-l-4 border-[#E85A2C]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
                  Patient Lead Generation & Nurturing
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Our patient acquisition funnels and email automation sequences capture potential patients and nurture them through the appointment booking journey. We turn interested prospects into scheduled consultations and scheduled consultations into long-term patients.
                </p>
              </div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e6e9f7]"
            >
              <img 
                src="/images/meta5.png" 
                alt="Patient Lead Generation"
                className="w-full h-full min-h-[200px] object-cover"
              />
            </motion.div>
          </div>

          {/* Benefit 4 - Image Left */}
          <div className="grid lg:grid-cols-2 gap-0">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#fce8e8] order-2 lg:order-1"
            >
              <img 
                src="/images/meta8.gif" 
                alt="Healthcare Analytics"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#fff0e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#19354a]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
                  Data-Driven Optimization
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We continuously monitor campaign performance and use data insights to optimize for better patient acquisition results. Our transparent reporting keeps you informed about cost per patient, appointment rates, and practice growth metrics.
                </p>
              </div>
            </motion.div>
          </div>

        </div>
      </section>



        {/*  ENTRUST US SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-2">
               Entrust us to Grow
              </h2>
              <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Your Practice Visibility,
              </h2>
              <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-2">
               Attract Qualified Patients
              </h3>
              <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-8">
                and Convert Them into Appointments.
              </h3>
      
              {/* Checklist Items */}
              <div className="space-y-5">
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.1 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                  We use proven healthcare marketing frameworks and patient acquisition systems that focus on long-term practice growth, not short-term spikes that fade away.
                  </p>
                </motion.div>
      
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.2 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                   Stay fully informed with live campaign tracking through tools like Google Ads, Meta Ads Manager, and practice management dashboards so you always know what's driving patient appointments.
                  </p>
                </motion.div>
      
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Monitor patient acquisition campaigns with professional analytics tools like Google Analytics and healthcare CRM integrations for complete visibility into ROI.
                  </p>
                </motion.div>
      
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.4 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                   Prioritize and scale as you choose. As <span className="text-[#19354a] font-semibold">healthcare marketing specialists</span>, we keep you in control — sharing insights, patient acquisition metrics, and strategic feedback so you can focus on what brings the highest patient value.
                  </p>
                </motion.div>
              </div>
            </motion.div>
      
            {/* Right - Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex justify-center"
            >
              <img 
                src="/images/services-2.png" 
                alt="Scale Your Practice"
                className="w-full max-w-[500px] h-auto"
              />
            </motion.div>
      
          </div>
        </div>
      </section>


      {/*  OUR SUITE OF SERVICES SECTION  */}
{/* <section className="py-16 bg-[#fff5f5]"> */}
<section className="py-16 bg-[#b2c3e6]">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-2 gap-12 items-start">
      
      {/* Left - Cards Grid */}
      <div>
        {/* Section Header */}
        <motion.h2 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-8"
        >
          Our Suite of <span className="text-[#19354a]">Healthcare</span>
          <br />
          <span className="text-[#19354a]">Marketing</span> Services for Doctors
        </motion.h2>

        {/* Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          
          {/* Card 1 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="bg-[#e0f7f7] rounded-xl p-4 flex flex-col items-center text-center hover:shadow-lg transition-all"
          >
            <img src="/images/13.png" alt="Practice Branding" className="w-12 h-12 mb-3 object-contain" />
            <p className="text-gray-800 text-sm font-medium">Practice Branding</p>
          </motion.div>

          {/* Card 2 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.15 }}
            className="bg-[#e0f7f7] rounded-xl p-4 flex flex-col items-center text-center hover:shadow-lg transition-all"
          >
            <img src="/images/14.png" alt="Content Management" className="w-12 h-12 mb-3 object-contain" />
            <p className="text-gray-800 text-sm font-medium">Healthcare Content Management</p>
          </motion.div>

          {/* Card 3 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="bg-[#e0f7f7] rounded-xl p-4 flex flex-col items-center text-center hover:shadow-lg transition-all"
          >
            <img src="/images/15.png" alt="Profile Creation" className="w-12 h-12 mb-3 object-contain" />
            <p className="text-gray-800 text-sm font-medium">Medical Profile Creation</p>
          </motion.div>

          {/* Card 4 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.25 }}
            className="bg-[#e0f7f7] rounded-xl p-4 flex flex-col items-center text-center hover:shadow-lg transition-all"
          >
            <img src="/images/16.png" alt="Content Strategy" className="w-12 h-12 mb-3 object-contain" />
            <p className="text-gray-800 text-sm font-medium">Patient Engagement Strategy</p>
          </motion.div>

          {/* Card 5 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="bg-[#e0f7f7] rounded-xl p-4 flex flex-col items-center text-center hover:shadow-lg transition-all"
          >
            <img src="/images/17.png" alt="Building Community" className="w-12 h-12 mb-3 object-contain" />
            <p className="text-gray-800 text-sm font-medium">Building Patient Community</p>
          </motion.div>

          {/* Card 6 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.35 }}
            className="bg-[#e0f7f7] rounded-xl p-4 flex flex-col items-center text-center hover:shadow-lg transition-all"
          >
            <img src="/images/18.png" alt="Organic Marketing" className="w-12 h-12 mb-3 object-contain" />
            <p className="text-gray-800 text-sm font-medium">Organic Healthcare Marketing</p>
          </motion.div>

          {/* Card 7 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.4 }}
            className="bg-[#e0f7f7] rounded-xl p-4 flex flex-col items-center text-center hover:shadow-lg transition-all"
          >
            <img src="/images/19.png" alt="Influencers" className="w-12 h-12 mb-3 object-contain" />
            <p className="text-gray-800 text-sm font-medium">Medical Influencer Partnerships</p>
          </motion.div>

          {/* Card 8 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.45 }}
            className="bg-[#e0f7f7] rounded-xl p-4 flex flex-col items-center text-center hover:shadow-lg transition-all"
          >
            <img src="/images/20.png" alt="Platform Management" className="w-12 h-12 mb-3 object-contain" />
            <p className="text-gray-800 text-sm font-medium">Platform-Specific Practice Management</p>
          </motion.div>

        </div>
      </div>

      {/* Right - Content */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="lg:pt-20"
      >
        <p className="text-gray-700 leading-relaxed mb-6">
          Recognized as the <span className="text-[#19354a] font-semibold">best healthcare Growth Ecosystem company for doctors</span>, we offer tailored patient acquisition solutions that amplify your medical practice's reach and impact. From crafting HIPAA-compliant content to running targeted ad campaigns and building strategic healthcare partnerships, our services are designed to deliver real, measurable patient growth.
        </p>
        <p className="text-gray-700 leading-relaxed">
          Trust us to elevate your practice’s online presence and drive sustainable patient acquisition across all major platforms. We combine data-driven healthcare marketing strategies with advanced SEO techniques to improve visibility, build credibility, and attract the right patients at the right time. From local search optimization and reputation management to high-converting content and performance tracking, our tailored approach ensures consistent growth, stronger patient engagement, and long-term success for your practice.

        </p>
      </motion.div>

    </div>
  </div>
</section>

      {/*  FAQ SECTION  */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
              Frequently Asked Questions about
            </h2>
            <h3 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
              Healthcare Marketing Services.
            </h3>
          </motion.div>

          {/* FAQ Content - Image Left, Questions Right */}
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            
            {/* Left - Image */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex justify-center lg:sticky lg:top-24"
            >
              <img 
                src="/images/faq-img.png" 
                alt="FAQ Healthcare Marketing"
                className="w-full max-w-[250px] h-auto"
              />
            </motion.div>

            {/* Right - FAQ Items */}
            <div className="space-y-4">
              {[
                {
                  question: "Which platforms should my medical practice advertise on?",
                  answer: "It depends on your specialty and target patient demographics. General practitioners often see great results with Google Ads and Facebook, while specialists may benefit from LinkedIn for professional referrals. We analyze your practice and recommend the best platforms for patient acquisition."
                },
                {
                  question: "How much should I budget for healthcare advertising?",
                  answer: "Budget depends on your location, specialty, and competition. We recommend starting with a test budget to gather patient data, then scaling based on cost per appointment. Our team helps optimize your spend for maximum patient ROI regardless of budget size."
                },
                {
                  question: "How long does it take to see results from medical practice ads?",
                  answer: "Paid advertising can generate patient leads within days, while building a strong organic presence typically takes 3-6 months. We set realistic expectations and provide regular updates on appointment bookings and patient inquiries."
                },
                {
                  question: "Do you create HIPAA-compliant content for healthcare ads?",
                  answer: "Yes! Our healthcare marketing team creates engaging, HIPAA-compliant content tailored to medical practices. We develop content calendars, write patient-focused copy, and design visuals that align with your practice brand and resonate with prospective patients."
                },
                {
                  question: "How do you measure healthcare marketing success?",
                  answer: "We track key metrics including patient inquiries, appointment bookings, cost per patient acquisition, and return on ad spend. You'll receive detailed monthly reports with insights on what's driving patients to your practice and recommendations for optimization."
                }
              ].map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                  <details className="group">
                    <summary className="flex items-center justify-between p-5 bg-[#19354a] rounded-lg cursor-pointer list-none">
                      <span className="font-semibold text-white">{faq.question}</span>
                      <span className="text-white text-2xl font-light group-open:hidden">+</span>
                      <span className="text-white text-2xl font-light hidden group-open:block">−</span>
                    </summary>
                    <div className="px-5 py-4 bg-gray-50 rounded-b-lg text-gray-700 leading-relaxed -mt-2">
                      {faq.answer}
                    </div>
                  </details>
                </motion.div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/*  CTA SECTION  */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6"
          >
            Ready to Grow Your Patient Base?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-gray-600 text-lg mb-8"
          >
            Let our healthcare marketing experts help you attract more patients and grow your medical practice.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link 
              to="/contact" 
              className="px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
            >
              Get a Free Consultation
            </Link>
            <a 
              href="tel:+918920845297" 
              className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all"
            >
              Call Us Now
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MarketingClientAcquisition;  